var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('SiteMasthead',{attrs:{"thin":"true","title":"Tips And Tricks"}}),_c('ContentRow',{attrs:{"noPaddingTop":true}},[_c('ContentContainer',[_c('SectionTitle')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }